export const fetchNewsData = async () => {
    try {
        const response = await fetch('./content/about/page-components/article/news.json', {
            cache: "no-cache"
        });
        let newsData = await response.json();
        newsData = newsData.filter(newsItem => {
            return newsItem && !newsItem.archived;
        });
        return newsData;
    } catch (e) {
        console.log(e)
    }
};



// WEBPACK FOOTER //
// ./src/api/fetchNewsData.js